export default __webpack_public_path__ + "static/media/Lord.e0ce0b7d.svg";